<template>
  <span>
    <component :is="modalWrapperComponent" to="modal" slim v-if="isOpen">
      <b-modal v-bind="{ ...$attrs }" :active.sync="isOpen" has-modal-card>
        <div
          class="modal-card"
          :class="{
            'has-modal-small': size === 'small',
            'has-modal-medium': size === 'medium',
            'has-modal-large': size === 'large',
          }"
        >
          <header class="modal-card-head">
            <div class="modal-card-title">
              <p data-test="modal-title">
              {{ title }}
              </p>
              <slot name="modalSubtitle"></slot>
            </div>
            <button
              class="close-icon"
              type="button"
              @click.stop.prevent="isOpen = false"
            >
              <i class="mdi mdi-close"></i>
            </button>
          </header>
          <div
            :class="[
              'modal-card-body',
              modalBodyClass,
              noFooter ? 'modal-card-body-no-footer' : '',
              notScrollable ? 'modal-card-body-not-scrollable' : '',
            ]"
          >
            <slot
              name="modalBody"
              :closeModal="() => (isOpen = false)"
              :isOpen="isOpen"
            >
            </slot>
          </div>
          <footer class="modal-card-foot" v-if="!noFooter">
            <slot
              name="modalFoot"
              :closeModal="() => (isOpen = false)"
              :isOpen="isOpen"
            >
            </slot>
          </footer>
        </div>
      </b-modal>
    </component>
    <!-- slot for button -->
    <slot name="openBtn" :openModal="() => (isOpen = true)">
      <button class="button is-primary" @click="isOpen = true">
        <i class="mdi mdi-pencil is-block"></i>
      </button>
    </slot>
  </span>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DummySpan from './DummySpan.vue';
import {isTruthy} from '../util/watcher.vue-decorator';
@Component({ components: { DummySpan } })
export default class BaseModal extends Vue {
  @Prop(String) public title!: string;
  @Prop(String) public modalBodyClass!: string;
  @Prop({ type: Boolean, default: false })
  public noFooter!: boolean;
  @Prop(Boolean) public usePortal!: boolean;
  @Prop(Boolean) public notScrollable!: boolean;
  @Prop({ type: String, default: 'small' })
  public size!: string;
  public isOpen = false;
  @Prop({ type: Boolean, default: false })
  public isModalOpen!: boolean;
  public closeModal() {
    this.isOpen = false;
  }

  @Watch('isOpen')
  public watchIsOpen() {
    if (this.isOpen) {
      this.$emit('open');
    } else {
      this.$emit('close');
      this.$emit('update:isModalOpen', false);
    }
  }

  @Watch ('isModalOpen')
  @isTruthy
  public watchIsModalOpen() {
    this.isOpen = true;
  }

  public created() {
    if (this.isModalOpen === true) {
      this.isOpen = true;
    }
  }
  get modalWrapperComponent() {
    return this.usePortal ? 'portal' : 'DummySpan';
  }
}
</script>
